<template>
  <v-snackbar
    :timeout="6000"
    v-model="messageOn"
    :color="error ? 'error':''"
  >
    {{ message }}
    <v-btn flat :color="error ? '': 'blue'" @click.native="messageOn = false; message = '';">Close</v-btn>
  </v-snackbar>
</template>

<script>
  import bus from '../bus';

  export default {

    data() {
      return {
        messageOn: false,
        message: '',
        error: false
      };
    },

    created() {
      bus.$on('toast-message-show', message => {
        this.message = this.nl2br(message.text);
        this.messageOn = true;
        this.error = message.error || false;
      });
    },

    methods: {

      nl2br(str) {
        const breakTag = '<br />';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
      }

    }
  };
</script>


// WEBPACK FOOTER //
// src/components/ToastMessage.vue